import { Link } from 'react-router-dom';
import { films, typeLabel } from '@/mocks/films';

const latest = [...films]
  .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
  .slice(0, 7);

export default function LatestUpdates() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3.5 md:px-5">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-flashlight-line text-sm w-4 h-4 flex items-center justify-center" />
          </span>
          <h2 className="font-heading text-base font-bold text-foreground-950">最新更新</h2>
        </div>
        <span className="font-label text-[11px] text-foreground-400">持续整理中</span>
      </div>
      <ul className="divide-y divide-background-200/80">
        {latest.map((film, i) => (
          <li key={film.id}>
            <Link
              to={`/detail/${film.id}`}
              className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:px-5 cursor-pointer"
            >
              <span className="w-5 shrink-0 font-label text-sm font-bold text-background-400 group-hover:text-accent-500">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="relative h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={film.poster}
                  alt={`${film.title}封面`}
                  title={`${film.title}剧情介绍 - 同学的妈妈`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600">
                  {film.title}
                </span>
                <span className="mt-1 flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
                  <span className="rounded bg-secondary-100 px-1 py-0.5 text-secondary-900">
                    {typeLabel[film.type]}
                  </span>
                  <span>{film.year}</span>
                  <span className="h-2.5 w-px bg-background-300" />
                  <span className="truncate">{film.genres.slice(0, 2).join(' · ')}</span>
                </span>
              </span>
              <span className="hidden shrink-0 font-label text-[11px] text-foreground-400 sm:block">
                {film.updatedAt.slice(5).replace('-', '/')}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}